export default "__VITE_ASSET__BfoS3gj___"